import fs from 'fs-extra';
import path from 'path';

import { getResolvedLocalesAsync } from './ExponentTools';

export async function writeLocalizationResourcesAsync({
  projectRoot,
  supportingDirectory,
  context,
}) {
  let locales = {};
  if (context.type === 'user') {
    locales = await getResolvedLocalesAsync(projectRoot, context.config);
  } else if (context.type === 'service') {
    locales = context.config.locales !== undefined ? context.config.locales : {};
  }
  for (const [lang, localizationObj] of Object.entries(locales)) {
    const dir = path.join(supportingDirectory, `${lang}.lproj`);
    fs.mkdirpSync(dir);
    const strings = path.join(dir, 'InfoPlist.strings');
    const buffer = [];
    for (const [plistKey, localVersion] of Object.entries(localizationObj)) {
      buffer.push(`${plistKey} = "${localVersion}";`);
    }
    await fs.writeFile(strings, buffer.join('\n'));
  }
}
